'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { cn } from '../../../utils/entry.js';
const SCROLL_MULTIPLIER = 1.5;
/**
 * Container that is draggable to scroll horizontally (overflow x).
 *
 * @param root0 input object
 * @param root0.children the items/content to be able to scroll
 * @param root0.className classes to add to the parent
 * @param root0.isPreventingClickPropagation wether or not to stop allowing this container to be clicked and thus not draggable anymore
 * @returns A container that makes the childs scroll-draggable with mouse on desktop.
 */
export default function DraggableContainer({ children, className, isPreventingClickPropagation = true, }) {
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const handleClick = (e) => {
        if (isPreventingClickPropagation) {
            e.preventDefault();
            e.stopPropagation();
        }
    };
    const startDrag = (e) => {
        e.preventDefault();
        setIsDragging(true);
        setStartX(e.pageX - e.currentTarget.offsetLeft);
        setScrollLeft(e.currentTarget.scrollLeft);
    };
    const stopDrag = () => {
        setIsDragging(false);
    };
    const onDrag = (e) => {
        if (!isDragging) {
            return;
        }
        e.preventDefault();
        const x = e.pageX - e.currentTarget.offsetLeft;
        const newPositionX = (x - startX) * SCROLL_MULTIPLIER;
        e.currentTarget.scrollLeft = scrollLeft - newPositionX;
    };
    return (_jsx("div", { "aria-label": "draggable-container", role: "button", tabIndex: 0, className: cn('h-full overflow-x-auto pb-2', isDragging ? 'cursor-grabbing' : 'cursor-grab', className), onClick: handleClick, onMouseDown: startDrag, onMouseLeave: stopDrag, onMouseMove: onDrag, onMouseUp: stopDrag, children: children }));
}
//# sourceMappingURL=DrawCard.DraggableContainer.js.map